import React from "react";
import { CommandmentStatusProps } from "./CommandmentStatus.props";
import { P } from "common/P/P";

const CommandmentStatus: React.FC<CommandmentStatusProps> = ({
	status,
	size = "t1",
}) => {
	switch (status) {
		case "Täze kabul edildi":
			return (
				<div className="px-3 py-1 bg-lowOpacity rounded-[4px] w-max">
					<P size={size} type="regular" className="text-mainColor">
						Täze kabul edildi
					</P>
				</div>
			);
		case "Ýerine ýetirmedi":
			return (
				<div className="px-3 py-1 bg-redBgColor rounded-[4px] w-max">
					<P size={size} type="regular" className="text-redColor">
						Ýerine ýetirmedi
					</P>
				</div>
			);
		case "Ýerine ýetirildi":
			return (
				<div className="px-3 py-1 bg-greenBgColor rounded-[4px] w-max">
					<P size={size} type="regular" className="text-greenColor">
						Ýerine ýetirildi
					</P>
				</div>
			);

		default:
			return null;
	}
};

export default CommandmentStatus;
